var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('data-table',{ref:"payment_fileList",attrs:{"model":_vm.model,"endpoint":_vm.$route.meta.endpoint},on:{"action":_vm.doAction}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }